export default __webpack_public_path__ + "5f5e2648ab130ff5c7932683755fa4cb.svg";